/*export const PHOTOS_COLOR: string = '#adadad'
export const FRONT_PHOTOS_COLOR: string = '#e74c3c';
export const BACK_PHOTOS_COLOR: string = '#2980b9';
export const NADIR_PHOTOS_COLOR: string = '#f1c40f';*/
export const GET_PHOTOS: string = 'get_photos';
export const GET_PHOTOS_SUCCESS: string = 'get_photos_success';
export const GET_PHOTOS_FAIL: string = 'get_photos_fail';
export const GET_PHOTO_FAULTS: string = 'get_photo_faults';
export const GET_PHOTO_FAULTS_SUCCESS: string = 'get_photo_faults_success';
export const GET_PHOTO_FAULTS_FAIL: string = 'get_photo_faults_fail';
export const DELETE_PHOTO: string = 'delete_photo';
export const DELETE_PHOTO_SUCCESS: string = 'delete_photo_success';
export const DELETE_PHOTO_FAIL: string = 'delete_photo_fail';
export const SELECT_PHOTO: string = 'select_photo';
export const REMOVE_PHOTO_SELECTION: string = 'remove_photo_selection';



// WEBPACK FOOTER //
// ./src/types/photos.jsx